import { apiClient } from '@/shared/api/client'

export async function getMarketing(params = {}) {
  const response = await apiClient.get('/admin/marketing', {
    params,
  })

  return response.data
}

export async function createMarketing(payload) {
  const response = await apiClient.post('/admin/marketing', payload)

  return response.data
}

export async function updateMarketing(id, payload) {
  const response = await apiClient.put(`/admin/marketing/${id}`, payload)

  return response.data
}

export async function deleteMarketing(id) {
  const response = await apiClient.delete(`/admin/marketing/${id}`)

  return response.data
}
